<template>
  <div class="input-code">
    <input ref="input" @input="inputFunc($event.target)" @focus="onFocus" @blur="onBlur" :placeholder="placeholder">
    <img src="../../assets/images/magnifier.png" alt="" class="magnifier" @click="search">
  </div>
</template>

<script>
export default _extend({
  name: 'AddressSearch',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    addressSearch: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      inputValue: ''
    };
  },
  methods: {
    handleClick() {},
    inputFunc(target) {
      this.inputValue = target.value;
    },
    toggle(status) {
      this.status = status;
    },
    clear() {
      this.$refs.input.value = '';
    },
    onFocus(e) {
      this.$refs.input.placeholder = '';
      this.setFocus();
    },
    onBlur(e) {
      this.$refs.input.placeholder = this.placeholder;
    },
    setFocus() {
    },
    search() {
      // window.console.log('搜索');
      this.addressSearch(this.inputValue);
    }
  },
  computed: {
  }
});
</script>

<style lang="scss" scoped>
@import './AddressSearch.scss';
</style>



// WEBPACK FOOTER //
// src/components/AddressSearch/AddressSearch.vue